import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_checkbox_field = _resolveComponent("checkbox-field")

  return (_openBlock(), _createElementBlock("fieldset", null, [
    _createVNode(_component_checkbox_field, {
      modelValue: $options.model,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($options.model) = $event)),
      disabled: $props.readOnly,
      class: "_mt-0",
      type: "radio",
      "checked-value": _ctx.customerEntityTypes.individual,
      "custom-label-text": _ctx.Resources.Checkout.CustomerEntityTypeIndividualLabel,
      "data-qa": "customer-entity-type:Individual"
    }, null, 8 /* PROPS */, ["modelValue", "disabled", "checked-value", "custom-label-text"]),
    _createVNode(_component_checkbox_field, {
      modelValue: $options.model,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (($options.model) = $event)),
      disabled: $props.readOnly,
      type: "radio",
      "checked-value": _ctx.customerEntityTypes.business,
      "custom-label-text": _ctx.Resources.Checkout.CustomerEntityTypeBusinessLabel,
      "data-qa": "customer-entity-type:Business"
    }, null, 8 /* PROPS */, ["modelValue", "disabled", "checked-value", "custom-label-text"])
  ]))
}